import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box,
    Typography,
    SelectChangeEvent,
    CircularProgress,
    Divider,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    FormHelperText,Table,TableCell, TableRow, TableHead,TableBody
} from '@mui/material';
import Heading from '../../Components/Heading/heading.tsx';
import { toast } from 'react-toastify';
import {
    getEarningsDeductionType,
    getWarehouseCompanyMapping,
    getFrequencyType,
    addEarningDeductionTypesWarehouse,
    addFrequencyType,addEarningType,getEarningDeductionTypeWarehouse
} from './action.ts';
import '../../Components/Button/button-style.scss';

export interface AddEarningsData {
    earningType: string;
    fuelType: string;
    warehouse: string;
    frequency: string;
    amount: number;
    description?: string;
}

interface AddEarningsDialogProps {
    open: boolean;
    onClose: () => void;
    onSubmit: (data: AddEarningsData) => void;
    title?: string;
}

interface DropdownOption {
    id: string | number;
    label: string;
    value?: string;
    isAddOption?: boolean;
}

const AddEarningsDialog: React.FC<AddEarningsDialogProps> = ({
    open,
    onClose,
    onSubmit,
    title = "Add Earnings",
}) => {
    const [formData, setFormData] = useState<AddEarningsData>({
        earningType: '',
        fuelType: '',
        warehouse: '',
        frequency: '',
        amount: 0,
        description: '',
    });

    const [errors, setErrors] = useState<Record<string, string>>({});
    const [earningTypes, setEarningTypes] = useState<DropdownOption[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [errorFetchingTypes, setErrorFetchingTypes] = useState<string>('');
    const [warehouseOptions, setWarehouseOptions] = useState<{ id: string, label: string }[]>([]);
    const [frequencyOptions, setFrequencyOptions] = useState<DropdownOption[]>([]);
    const [selectedEarningTypeId, setSelectedEarningTypeId] = useState<string>('');
    const [selectedWarehouseId, setSelectedWarehouseId] = useState<string>('');
    const [selectedFrequencyId, setSelectedFrequencyId] = useState<string>('');
    const [submitting, setSubmitting] = useState<boolean>(false);  
    const [openEarningTypeDialog, setOpenEarningTypeDialog] = useState<boolean>(false);
    const [openFrequencyDialog, setOpenFrequencyDialog] = useState<boolean>(false);
    const [newEarningType, setNewEarningType] = useState<string>('');
    const [newFrequencyType, setNewFrequencyType] = useState<string>('');
    const [addingEarningType, setAddingEarningType] = useState<boolean>(false);
    const [addingFrequency, setAddingFrequency] = useState<boolean>(false);
    const [type,setType]=useState<string>('');
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const [warehouseMappings, setWarehouseMappings] = useState<any[]>([]);
    const [showPlusButton, setShowPlusButton] = useState(false);
    const [showWarehouseList, setShowWarehouseList] = useState(false);
    const [loadingWarehouseMapping, setLoadingWarehouseMapping] = useState(false);

    const companiesId = userDetailsFromStorage?.companies_id || '';

    const fuelTypeOptions: DropdownOption[] = [
        { id: 'diesel', label: 'Diesel', value: 'diesel' },
        { id: '2W-EV', label: '2 Wheeler EV', value: '2W-EV' },
        { id: '3W-EV', label: '3 Wheeler EV', value: '3W-EV' },
        { id: 'petrol', label: 'Petrol', value: 'petrol' },
        { id: 'CNG', label: 'CNG', value: 'CNG' },
    ];

       const typeOptions = [
        { id: 'earnings', label: 'Earnings', value: 'earnings' },
        { id: 'deductions', label: 'Deductions', value: 'deductions' },
    ];

    const ADD_EARNING_TYPE_OPTION: DropdownOption = {
        id: 'add-earning-type',
        label: '+ Add earning type',
        isAddOption: true
    };

    const ADD_FREQUENCY_OPTION: DropdownOption = {
        id: 'add-frequency-type',
        label: '+ Add frequency type',
        isAddOption: true
    };

    useEffect(() => {
        if (open) {
            fetchEarningTypes();
            fetchWarehouses();
            fetchFrequencyTypes();
        }
    }, [open]);
const fetchEarningDeductionTypeWarehouse = (warehouseId: string) => {
    setLoadingWarehouseMapping(true);
    setShowPlusButton(false);
    setShowWarehouseList(false);

    getEarningDeductionTypeWarehouse(
        warehouseId,
        (response: any) => {
            if (response?.status === 200 && response?.data?.length > 0) {
                setWarehouseMappings(response.data);
                setShowPlusButton(true);
            } else {
                setWarehouseMappings([]);
                setShowPlusButton(false);
            }
            setLoadingWarehouseMapping(false);
        },
        (error: any) => {
            toast.error(error.message || 'Failed to load data');
            setWarehouseMappings([]);
            setShowPlusButton(false);
            setLoadingWarehouseMapping(false);
        }
    );
};

    const fetchWarehouses = () => {
        getWarehouseCompanyMapping(
            companiesId,
            (response: any) => {
                const options = response.user_warehouses.map((warehouses: any) => ({
                    id: warehouses.warehouse.id,
                    label: warehouses.warehouse.name,
                }));
                setWarehouseOptions(options);
            },
            (errMessage: any) => {
                toast.error(errMessage.message);
            }
        );
    };

    const fetchFrequencyTypes = () => {
        getFrequencyType(
            (response: any) => {
                if (response?.status === 200 && response?.data) {
                    const transformedFrequencies = response.data.map((item: any) => ({
                        id: String(item.id),
                        label: item.name
                    }));

                    setFrequencyOptions(transformedFrequencies);
                } else {
                    toast.error('Failed to load frequency types');
                }
            },
            (error: any) => {
                toast.error('Failed to load frequency types');
                setFrequencyOptions([]);
            }
        );
    };

    const fetchEarningTypes = async () => {
        setLoading(true);
        setErrorFetchingTypes('');

        try {
            getEarningsDeductionType(
                (response: any) => {
                    if (response?.status === 200 && response?.data) {
                        const transformedTypes = response.data.map((item: any) => ({
                            id: String(item.id),
                            label: item.name || item.label
                        }));
                        setEarningTypes(transformedTypes || []);
                    } else {
                        setErrorFetchingTypes('Invalid response format from server');
                        toast.error('Failed to load earning types');
                    }
                    setLoading(false);
                },
                (error: any) => {
                    setErrorFetchingTypes('Failed to load earning types. Please try again.');
                    toast.error('Failed to load earning types');
                    setLoading(false);
                }
            );
        } catch (error) {
            setErrorFetchingTypes('An unexpected error occurred.');
            toast.error('Failed to load earning types');
            setLoading(false);
        }
    };

    useEffect(() => {
        if (open) {
            setFormData({
                earningType: '',
                fuelType: '',
                warehouse: '',
                frequency: '',
                amount: 0,
                description: '',
            });
            setErrors({});
            setSelectedEarningTypeId('');
            setSelectedWarehouseId('');
            setSelectedFrequencyId('');
            setNewEarningType('');
            setNewFrequencyType('');
        }
    }, [open]);

    const getEarningTypeOptions = () => {
        return [...earningTypes, ADD_EARNING_TYPE_OPTION];
    };

    const getFrequencyOptions = () => {
         return [...frequencyOptions];
        // return [...frequencyOptions, ADD_FREQUENCY_OPTION];
    };

    const CustomDropdown = ({
        options,
        selectedValue,
        handleChange,
        placeholder,
        label,
        width = '250px',
        height = '50px',
        name,
        error = false,
        helperText = '',
        disabled = false
    }: {
        options: DropdownOption[];
        selectedValue: string;
        handleChange: (e: SelectChangeEvent<string>) => void;
        placeholder: string;
        label: string;
        width?: string;
        height?: string;
        name: string;
        error?: boolean;
        helperText?: string;
        disabled?: boolean;
    }) => {
        const regularOptions = options.filter(option => !option.isAddOption);
        const addOptions = options.filter(option => option.isAddOption);

        return (
            <FormControl error={error} sx={{ width, height }} disabled={disabled}>
                <InputLabel>{label}</InputLabel>
                <Select
                    value={selectedValue}
                    onChange={handleChange}
                    label={label}
                    name={name}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                maxHeight: 300,
                            }
                        }
                    }}
                >
                    <MenuItem value="" disabled>
                        <em>{placeholder}</em>
                    </MenuItem>                
                    {regularOptions.map((option) => (
                        <MenuItem key={option.id} value={option.id.toString()}>
                            {option.label}
                        </MenuItem>
                    ))}
                    
                    {addOptions.length > 0 && regularOptions.length > 0 && (
                        <Divider sx={{ my: 0.5 }} />
                    )}
                    
                    {addOptions.map((option) => (
                        <MenuItem 
                            key={option.id} 
                            value={option.id.toString()}
                            sx={{
                                fontStyle: 'italic',
                                color: 'primary.main',
                                '&:hover': {
                                    backgroundColor: 'primary.light',
                                    color: 'primary.contrastText',
                                }
                            }}
                        >
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
                {helperText && <FormHelperText>{helperText}</FormHelperText>}
            </FormControl>
        );
    };

    const handleEarningTypeChange = (e: SelectChangeEvent<string>) => {
        const value = e.target.value;
        
        if (value === ADD_EARNING_TYPE_OPTION.id) {
            setOpenEarningTypeDialog(true);
            return;
        }
                
        setFormData(prev => ({
            ...prev,
            earningType: value,
        }));
        
        setSelectedEarningTypeId(value);
        
        const selectedOption = earningTypes.find(option => option.id.toString() === value);
        
        if (errors.earningType) {
            setErrors(prev => ({
                ...prev,
                earningType: '',
            }));
        }
    };

    const handleFrequencyChange = (e: SelectChangeEvent<string>) => {
        const value = e.target.value;
        if (value === ADD_FREQUENCY_OPTION.id) {
            setOpenFrequencyDialog(true);
            return;
        }
                
        setFormData(prev => ({
            ...prev,
            frequency: value,
        }));
        
        setSelectedFrequencyId(value);
        const selectedOption = frequencyOptions.find(option => option.id.toString() === value);        
        if (errors.frequency) {
            setErrors(prev => ({
                ...prev,
                frequency: '',
            }));
        }
    };
   const handleTypeChange = (e: SelectChangeEvent<string>) => {
        const value = e.target.value;
        setType(value);
    };

    const handleAddEarningType = () => {
        if (!newEarningType.trim()) {
            toast.error('Please enter an earning type name');
            return;
        }

        setAddingEarningType(true);
        addEarningType(newEarningType,type,
            (response)=>{toast.success(response.message);
                setTimeout(() => {
            const newId = `new-earning-${Date.now()}`;
            const newOption = {
                id: newId,
                label: newEarningType.trim()
            };
            
            setEarningTypes(prev => [...prev, newOption]);
            
            setFormData(prev => ({
                ...prev,
                earningType: newId,
            }));
            setSelectedEarningTypeId(newId);
            setNewEarningType('');
            setOpenEarningTypeDialog(false);
            setAddingEarningType(false);
        }, 1000);
            },(error)=>{toast.error(error.message)})
    
        
    };

    const handleAddFrequencyType = () => {
        if (!newFrequencyType.trim()) {
            toast.error('Please enter a frequency type name');
            return;
        }
        setAddingFrequency(true);
        addFrequencyType(newFrequencyType,
            (response:any)=>{
                toast.success(response.message);
             setTimeout(() => {
            const newId = `new-frequency-${Date.now()}`;
            const newOption = {
                id: newId,
                label: newFrequencyType.trim()
            };
            setFrequencyOptions(prev => [...prev, newOption]);
            setFormData(prev => ({
                ...prev,
                frequency: newId,
            }));
            setSelectedFrequencyId(newId);
            setNewFrequencyType('');
            setOpenFrequencyDialog(false);
            setAddingFrequency(false);
        }, 1000);},(error:any)=>{toast.error(error.message)})
       
    };

    const handleFuelTypeChange = (e: SelectChangeEvent<string>) => {
        const value = e.target.value;        
        setFormData(prev => ({
            ...prev,
            fuelType: value,
        }));
        
        if (errors.fuelType) {
            setErrors(prev => ({
                ...prev,
                fuelType: '',
            }));
        }
    };

    const handleWarehouseChange = (e: SelectChangeEvent<string>) => {
        const value = e.target.value;
        setFormData(prev => ({
            ...prev,
            warehouse: value,
        }));
        setSelectedWarehouseId(value);
        fetchEarningDeductionTypeWarehouse(value);

        const selectedOption = warehouseOptions.find(option => option.id.toString() === value);        
        if (errors.warehouse) {
            setErrors(prev => ({
                ...prev,
                warehouse: '',
            }));
        }
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        if (name === 'amount') {
            const numValue = parseFloat(value) || 0;
            setFormData(prev => ({
                ...prev,
                [name]: numValue,
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value,
            }));
        }
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: '',
            }));
        }
    };

    const validateForm = (): boolean => {
        const newErrors: Record<string, string> = {};

        if (!formData.earningType.trim()) {
            newErrors.earningType = 'Earning type is required';
        }

        if (!formData.fuelType.trim()) {
            newErrors.fuelType = 'Fuel type is required';
        }

        if (!selectedWarehouseId) {
            newErrors.warehouse = 'Warehouse is required';
        }

        if (!formData.frequency.trim()) {
            newErrors.frequency = 'Frequency is required';
        }

        if (!formData.amount || formData.amount <= 0) {
            newErrors.amount = 'Amount must be greater than 0';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async () => {
        if (!validateForm()) {
            toast.error('Please fill in all required fields correctly');
            return;
        }

        if (!selectedEarningTypeId || !selectedWarehouseId || !selectedFrequencyId) {
            toast.error('Please select valid options for all dropdowns');
            return;
        }

        setSubmitting(true);

        try {
            addEarningDeductionTypesWarehouse(
                selectedEarningTypeId,
                selectedWarehouseId,
                formData.amount,
                formData.fuelType,
                6,
                selectedFrequencyId,
                (response: any) => {
                    
                    if (response?.status === 200 || response?.status === 201) {
                       toast.success(response.message)
                        onClose();
                    } else {
                        const errorMsg = response?.message || 'Failed to add earning';
                        toast.error(errorMsg);
                    }
                    setSubmitting(false);
                },
                (error: any) => {
                    const errorMsg = error?.message || 'Failed to add earning. Please try again.';
                    toast.error(errorMsg);
                    setSubmitting(false);
                }
            );
        } catch (error) {
            toast.error('An unexpected error occurred. Please try again.');
            setSubmitting(false);
        }
    };

    return (
        <>
            <Dialog 
                open={open} 
                onClose={onClose}
                maxWidth="md"
                PaperProps={{
                    sx: {
                        borderRadius: '12px',
                        padding: '8px',
                    }
                }}
            >
                <Box sx={{ marginLeft: {
                    sm: '-180px', 
                }, }}>          
                    <Heading title={"Add Earning to Warehouse Mapping"} closeIcon="true" onClose={onClose} />
                </Box> 
                
                <DialogContent
                    sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                    }}
                    >

                   <Box
                        component="form"
                        sx={{
                            width: '100%', 
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                        }}
                        >

                        {loading && (
                            <Box display="flex" justifyContent="center" alignItems="center" py={2}>
                                <CircularProgress size={24} />
                                <Typography variant="body2" sx={{ ml: 2 }}>
                                    Loading earning types...
                                </Typography>
                            </Box>
                        )}
                        
                        {errorFetchingTypes && !loading && (
                            <Typography color="error" variant="body2">
                                {errorFetchingTypes}
                            </Typography>
                        )}
                        
<Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
    {/* LEFT: Warehouse dropdown */}
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CustomDropdown
                options={warehouseOptions.map(option => ({
                    ...option,
                    isAddOption: false
                }))}
                selectedValue={formData.warehouse}
                handleChange={handleWarehouseChange}
                placeholder="Choose Warehouse"
                label="Choose Warehouse *"
                width="250px"
                height="50px"
                name="warehouse"
                error={!!errors.warehouse}
                helperText={errors.warehouse}
            />

            {showPlusButton && (
                <Button
                    variant="outlined"
                    sx={{ minWidth: 40, height: 40 }}
                    onClick={() => setShowWarehouseList(prev => !prev)}
                >
                    {showWarehouseList ? '-' : '+'}
                </Button>
            )}
        </Box>
   <Box sx={{paddingTop:'5px'}}>
        <CustomDropdown
            options={fuelTypeOptions.map(option => ({...option, isAddOption: false}))}
            selectedValue={formData.fuelType}
            handleChange={handleFuelTypeChange}
            placeholder="Choose Fuel Type"
            label="Choose Fuel Type *"
            width='250px'
            height='50px'
            name="fuelType"
            error={!!errors.fuelType}
            helperText={errors.fuelType}
        />
</Box>
   <Box sx={{paddingTop:'5px'}}>
        <CustomDropdown
            options={getEarningTypeOptions()}
            selectedValue={formData.earningType}
            handleChange={handleEarningTypeChange}
            placeholder='Choose Earning Type'
            label="Choose Earning Type *"
            width='250px'
            height='50px'
            name='earningType'
            error={!!errors.earningType}
            helperText={errors.earningType}
            disabled={loading || !!errorFetchingTypes}
        />
</Box>
   <Box sx={{paddingTop:'5px'}}>
        <CustomDropdown
            options={getFrequencyOptions()}
            selectedValue={formData.frequency}
            handleChange={handleFrequencyChange}
            placeholder='Choose Frequency'
            label='Frequency *'
            width='250px'
            height='50px'
            name='frequency'
            error={!!errors.frequency}
            helperText={errors.frequency}
        />
        </Box>
   <Box sx={{paddingTop:'5px'}}>
        <TextField
            label="Amount *"
            name="amount"
            type="number"
            value={formData.amount || ''}
            sx={{height:'50px', width:'250px'}}
            onChange={handleInputChange}
            error={!!errors.amount}
            helperText={errors.amount}
            InputProps={{
                startAdornment: <Typography sx={{ mr: 1 }}>₹</Typography>,
            }}
            inputProps={{
                min: 0,
                step: 0.01,
            }}
        />
        </Box>
    </Box>

    {/* RIGHT: Expandable table - spans full height */}
    {showWarehouseList && (
        <Box
            sx={{
                minWidth: 300,
                maxWidth: 400,
                border: '1px solid #e0e0e0',
                borderRadius: 2,
                p: 1.5,
                backgroundColor: '#fafafa',
                height: '100%',
                alignSelf: 'stretch'
            }}
        >
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                Existing Earnings / Deductions
            </Typography>

            {loadingWarehouseMapping ? (
                <Box display="flex" justifyContent="center" py={2}>
                    <CircularProgress size={20} />
                </Box>
            ) : warehouseMappings.length === 0 ? (
                <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>
                    No existing records found
                </Typography>
            ) : (
                <Box sx={{ maxHeight: 300, overflow: 'auto' }}>
                    <Table size="small" stickyHeader>
                    <TableHead>
                    <TableRow>
                        <TableCell><b>Sl No</b></TableCell>
                        <TableCell><b>Name</b></TableCell>
                        <TableCell align="right"><b>Amount</b></TableCell>
                    </TableRow>
                    </TableHead>


                       <TableBody>
                            {warehouseMappings.map((item, index) => {
                                const isDeduction = item?.type?.type === 'deductions';

                                return (
                                <TableRow key={item.id}>
                                    <TableCell>{index + 1}</TableCell>

                                    <TableCell
                                    sx={{
                                        color: isDeduction ? 'error.main' : 'success.main',
                                        fontWeight: 600,
                                        textTransform: 'capitalize'
                                    }}
                                    >
                                    {item?.type?.name || '-'}
                                    </TableCell>

                                    <TableCell align="right">
                                    ₹{item.amount}
                                    </TableCell>
                                </TableRow>
                                );
                            })}
                            </TableBody>

                    </Table>
                </Box>
            )}
        </Box>
    )}
</Box>


    
                    </Box>
                </DialogContent>

                <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button 
                        onClick={onClose} 
                        className='custom-cancel-button'
                        disabled={submitting}
                    >
                        Cancel
                    </Button>
                    <Button 
                        onClick={handleSubmit} 
                        variant="contained"
                        className='custom-button'
                        disabled={loading || submitting}
                    >
                        {submitting ? (
                            <CircularProgress size={24} color="inherit" />
                        ) : (
                            'Add Earnings'
                        )}
                    </Button>
                </DialogActions>
            </Dialog>

           <Dialog
    open={openEarningTypeDialog}
    onClose={() => setOpenEarningTypeDialog(false)}
    maxWidth="sm"
    
>
    <Box sx={{ marginLeft: { sm: '-180px' } }}> 
        <Heading 
            title="Add Earning Type" 
            closeIcon="true" 
            onClose={() => setOpenEarningTypeDialog(false)} 
        />
    </Box>
    
    <DialogContent>
        <Box 
            sx={{ 
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                alignItems: 'flex-start',
            }}
        >
            <TextField
                autoFocus
                margin="dense"
                label="Earning Type Name"
                type="text"
                sx={{ width: '250px', height: '50px' }}
                variant="outlined"
                value={newEarningType}
                onChange={(e) => setNewEarningType(e.target.value)}
                onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                        handleAddEarningType();
                    }
                }}
            />
            <CustomDropdown
                options={typeOptions}
                selectedValue={type}
                handleChange={handleTypeChange}
                placeholder='Choose Type'
                label='Type *'
                width='250px'
                height='50px'
                name='type'
                error={!!errors.frequency}
                helperText={errors.frequency}
            />
        </Box>
    </DialogContent>
    
    <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
        <Button 
            onClick={() => setOpenEarningTypeDialog(false)}
            className='custom-cancel-button'
            disabled={addingEarningType}
        >
            Cancel
        </Button>
        <Button
            onClick={handleAddEarningType}
            variant="contained"
            className='custom-button'
            disabled={addingEarningType || !newEarningType.trim()}
        >
            {addingEarningType ? (
                <CircularProgress size={24} color="inherit" />
            ) : (
                'Add'
            )}
        </Button>
    </DialogActions>
</Dialog>
            <Dialog
                open={openFrequencyDialog}
                onClose={() => setOpenFrequencyDialog(false)}
                maxWidth="sm"
            >
                   <Box sx={{ marginLeft: {
                    sm: '-180px', 
                }, }}> 
                <Heading title="Add Frequency Type" closeIcon="true" onClose={() => setOpenFrequencyDialog(false)} /> </Box>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Frequency Type Name"
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={newFrequencyType}
                        onChange={(e) => setNewFrequencyType(e.target.value)}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                handleAddFrequencyType();
                            }
                        }}
                    />
                </DialogContent>
                <DialogActions  style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button 
                        onClick={() => setOpenFrequencyDialog(false)}
                        className='custom-cancel-button'
                        disabled={addingFrequency}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleAddFrequencyType}
                        variant="contained"
                        className='custom-button'
                        disabled={addingFrequency || !newFrequencyType.trim()}
                    >
                        {addingFrequency ? (
                            <CircularProgress size={24} color="inherit" />
                        ) : (
                            'Add'
                        )}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default AddEarningsDialog;